import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const get_feature_details = async (id) => {
  const requestObj = {
    path: `api/client/detail_client/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_feature_overview = async (source_slug, feature_slug) => {
  const requestObj = {
    path: `api/blog/blog_over_view?source_slug=${source_slug}&feature_slug=${feature_slug}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_types_list = async (feature) => {
  const requestObj = {
    path: `api/profile_type/active_profile_type?feature_slug=${feature}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_company_listing = async (
  source_slug,
  feature_slug,
  search = "",
  type_slug = "",
  page = 0,
  limit = 50
) => {
  const requestObj = {
    path: `api/client/get_company_list?source_slug=${source_slug}&feature_slug=${feature_slug}&profile_type=${type_slug}&search=${search}&page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const update_company_profile = async (userId, data) => {
  const requestObj = {
    path: `api/client/update_company_data/${userId}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_company_cover_photo = async (data) => {
  const requestObj = {
    path: `api/client/upload_client_cover_photo`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
